import r from "./_isArrayLike.js";
import t from "./values.js";
import o from "./_getLength.js";
import m from "./random.js";
import a from "./toArray.js";
function e(e, i, s) {
  if (null == i || s) return r(e) || (e = t(e)), e[m(e.length - 1)];
  var f = a(e),
    n = o(f);
  i = Math.max(Math.min(i, n), 0);
  for (var l = n - 1, p = 0; p < i; p++) {
    var u = m(p, l),
      j = f[p];
    f[p] = f[u], f[u] = j;
  }
  return f.slice(0, i);
}
export { e as default };